import React from 'react';
import styled from 'styled-components';
import { PromoIdentifier, gridConfig } from '@tvg/fuse-design';

interface Props {
  text: string;
  colour: string;
}

const Container = styled.div`
  margin: 0 calc(var(--spacing-space16) * -1);

  @media (min-width: ${gridConfig.m.minWidth}) {
    margin: 0 0 var(--spacing-space8);
  }

  @media (min-width: ${gridConfig.l.minWidth}) {
    margin-bottom: var(--spacing-space16);
  }
`;

const StyledPromotionIdentifier = styled(PromoIdentifier)`
  > * {
    font-size: var(--font-size-m2);
    line-height: var(--font-line-height-m2);

    @media (min-width: ${gridConfig.l.minWidth}) {
      font-size: var(--font-size-1);
      line-height: var(--font-line-height-1);
    }
  }
`;

function PromotionIdentifier({ text, colour }: Props) {
  return (
    <Container>
      <StyledPromotionIdentifier text={text} color={colour} />
    </Container>
  );
}

export default PromotionIdentifier;
